import { createActions } from "redux-actions";

export default createActions({
  COMMUNITIES: {
    MANAGER_RECRUITMENTS: {
      SUCCESS: (data) => ({ data }),
      FAILURE: (data) => ({ data }),
      GET_MANAGER_RECRUITMENT_DETAIL: (id) => ({ id }),
      GET_PREF_LIST: () => ({}),
      GET_CITY_LIST: (prefId) => ({ prefId }),
      GET_MY_CIRCLE_LIST: () => ({}),
      CREATE_MANAGER_RECRUITS_USERS: (
        companiesCirclesManagerRecruitId,
        companyId,
        communityId,
        userId,
        circleId,
        userComment,
        userPrefId,
        userAddress,
        userPostal,
        userTel,
        userFamilyname,
        userFirstname,
        facebookUrl,
        twitterUrl,
        instagramUrl
      ) => ({
        companiesCirclesManagerRecruitId,
        companyId,
        communityId,
        userId,
        circleId,
        userComment,
        userPrefId,
        userAddress,
        userPostal,
        userTel,
        userFamilyname,
        userFirstname,
        facebookUrl,
        twitterUrl,
        instagramUrl,
      }),
    },
  },
});
